
<template>
  <div class="animated fadeIn">
    <p>
      <!-- Exit -->
      After initial setup, the settings can be changed at any time.
      <b-button class="float-right" variant="link" @click="$parent.$emit('status', false)">Quick Guide Exit</b-button>
    </p>
    <b-card-group>
      <!-- .slideInDown
      .slideInLeft
      .slideInRight
      .slideInUp
      .slideOutDown
      .slideOutLeft
      .slideOutRight
      .slideOutUp -->
      <b-card v-if="step == 1" class="slideInDown slideOutDown">
        <!-- 안내 및 설정 방법 -->
        <b-row>
          <b-col class="text-center">
            <h3>
              Nice to meet you. You've installed a new agent!
            </h3>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col sm="12" class="text-center">
            <b-card-group deck style="cursor:pointer">
              <b-card bg-variant="primary" @click="list">
                <b-card-text>
                  <strong>Copy From Others policy</strong>
                  <hr>
                  <p>Apply different WSFinder settings</p>
                  <hr>
                  <p>
                    [Select Agent] -> [Setting] -> [Apply to other servers] -> [Apply]
                  </p>
                </b-card-text>
              </b-card>
              <b-card bg-variant="success" @click="next()">
                <b-card-text>
                  <strong>
                    Policy setting
                  </strong>
                  <hr>
                  <p>Set it up quickly and find the web shell hidden on the server.</p>
                  <hr>
                  <p>Start setting up your Anti-Webshell</p>
                </b-card-text>
              </b-card>
            </b-card-group>
          </b-col>
        </b-row>
      </b-card>
      <b-card v-if="step == 2" class="slideInLeft slideOutLeft">
        <h4>* Select your upload directory on the server</h4>
        <hr>
        <!-- {{scan_list}} -->
        <!-- 폴더 설정 설정 -->
        <folder-set
          :only_view="true"
          :show="dir.length"
          :item="dir"
          :scan_list="scan_list"
          :white_path="white_path"

          @path="(s) => $parent.$emit('get_path', s)"
          @remove="(type, s) => remove_select(type, s) && $parent.$emit('remove', type, s)"
          @clear="() => $parent.$emit('clear')"

          @add_white_list="add_white_list"
          @add_scan_list="add_scan_list"
          @white_path_one="white_path_one"

        >
        </folder-set>
      </b-card>

      <b-card v-if="step == 3" class="slideInLeft slideOutLeft">
        <!-- 점검 정책 설정해야 함 -->
        <b-row style="height:180px;">
          <b-col md="5" class="text-right">
            <center>
              <div :style="style('RoyalBlue')" style="position:relative;top:50px;left:+60px;" @click="rule_update('Regex')" >
                <span v-if="rule.indexOf('Regex') > -1">&#10003;</span>
                Regex
              </div>
              <div :style="style('crimson')" style="position:relative;top:-10px;" @click="rule_update('Hash')" >
                <span v-if="rule.indexOf('Hash') > -1">&#10003;</span>
                Hash
              </div>
              <div :style="style('skyblue')" style="position:relative;top:50px;left:-60px;" @click="rule_update('Url')" >
                <span v-if="rule.indexOf('Url') > -1">&#10003;</span>
                URL
              </div>
            </center>
          </b-col>
          <b-col>
            <p style="margin-top:18px; font-size:55px;">
              +
            </p>
          </b-col>

          <b-col md="5" class="text-left">

            <!-- @click="rule_update('Ssdeep')" -->
            <div :style="style('gold')">
              <span v-if="rule.indexOf('Ssdeep') > -1">&#10003;</span>
              SSDEEP
            </div>
            <!-- @click="rule_update('OB')" -->
            <div :style="style('orange')">
              <span v-if="rule.indexOf('OB') > -1">&#10003;</span>
              <small class="font-weight-bold">Obfuscation</small>
            </div>
            <p class="mt-3">
              * The quick setting does not support Optional
              <br>
              Additional settings can be set at detailed settings after quick settings
              <!-- This case if detect, Need a check file -->
            </p>

          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col>
            * Click Circle or Next(Default : [{{rule_text}}])
          </b-col>
        </b-row>
      </b-card>
      <b-card v-if="step == 4" class="slideInLeft slideOutLeft">
        <!-- 백업 모드 및 백업 경로 -->
        <b-row class="text-center">
          <b-col>
            * Is Optional Setting for Scheduling
            You can set quarantine of detected files to a specific path.
            <br>
            <br>
            If there is a malicious pattern in site code, there may be a problem with site because it isolates physical files.
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col md="4">
            * Plz, typeing full path for isolation
            <br>
            <span class="text-danger font-weight-bold">* Should be a folder is already</span>
          </b-col>
          <b-col md="8">
            <b-form-input v-model="isolation" placeholder="/etc/var/isolation or C:\\www\\isolation"></b-form-input>
          </b-col>
        </b-row>
      </b-card>
      <b-card v-if="step == 5" class="slideInLeft slideOutLeft">
        <b-row class="text-center">
          <b-col>
            * Is Optional Setting for Scheduling
          </b-col>
        </b-row>
        <hr>
        <!-- 스케줄 설정 -->
        <b-row class="text-center">
          <b-col>
            Please select an inspection schedule
          </b-col>
          <b-col>
            <Schedule :now_schedule="schedule" @save="x => { this.schedule = x }"/>
          </b-col>
        </b-row>
      </b-card>
    </b-card-group>
    <!-- 스탭 공통 처리 부분 -->
    <hr v-if="step < all">
    <b-button v-if="step > 1" block size="sm" variant="info" @click="prev()"> Prev </b-button>
    <b-button v-if="step < all"  block size="sm" variant="primary" @click="next()">Next </b-button>
    <b-button class="btn-add" v-else block size="sm" variant="success" @click="modal_save = true">Save </b-button>
    <hr>
    <b-row>
      <b-col>
        <center>{{step}} / {{all}}</center>
      </b-col>
    </b-row>
    <b-modal title="This setting Apply to agent(Anti-Webshell)"  class="modal-success" v-model="modal_save" @ok="apply" ok-variant="success" header-bg-variant="warning">
      Should apply the settings ?
      <hr>
      Once the settings have been saved,
      <br>
      you can check them on the "Checking" tab.
      <br>
      Settings can be changed at any time.
    </b-modal>
    <!-- 디버그 영역 -->
    <!-- {{}} -->
  </div>
</template>
<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>
